import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useParams } from 'react-router'

import { GET_USERS } from '../users/queries'
import { User } from './user'

export function UserContainer() {
    const { id } = useParams()

    const { data, loading } = useQuery(GET_USERS, {
        variables: {
            filter: {
                id: { eq: id },
            },
        },
    })

    const userData = useMemo(() => {
        if (
            data?.listUserProfiles?.items &&
            data.listUserProfiles.items.length
        ) {
            return data.listUserProfiles.items[0]
        } else {
            return null
        }
    }, [data])

    return <User loading={loading} user={userData} />
}
